import theme from '@/style';
import React from 'react';
import {useTranslation} from 'react-i18next';

const coinIcon = require('@components/assets/icons/bets/coin.webp');

const ShareButton = ({
  onShare = () => {},
  hasAward = false,
}: {
  onShare?: () => void;
  hasAward: boolean;
}) => {
  const {i18n} = useTranslation();

  return (
    <button
      type="button"
      onClick={() => onShare()}
      className="flex items-center rounded border-0 px-2 py-1.5 font-InterBold text-sm text-white"
      style={{backgroundColor: theme.basicColor.primary}}>
      {hasAward ? <img src={coinIcon} alt="" className="mr-1 h-5 w-5" /> : null}
      <span>
        {hasAward
          ? i18n.t('bets-page.label.shareAwards')
          : i18n.t('bets-share.label.share')}
      </span>
    </button>
  );
};

export default ShareButton;
